// extracted by mini-css-extract-plugin
export default {"wrapper":"bulkSpareDetailPage_wrapper__RCpXU","box":"bulkSpareDetailPage_box__P8lJi","box__section":"bulkSpareDetailPage_box__section__cw399"};